module.exports = __webpack_public_path__ + "img/deleteJD.bbad7d2e.svg";